export const TIMELINE_ZOOM_LEVELS = Object.freeze([
  0.1,
  0.15,
  0.2,
  0.3,
  0.4,
  0.5,
  0.6,
  0.75,
  1,
  1.25,
  1.5,
  2,
  2.5,
  3,
  4,
  5,
  6,
  7.5,
  10,
]);

function findClosestZoomIndex(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return TIMELINE_ZOOM_LEVELS.indexOf(1);
  }

  let bestIndex = 0;
  let bestDistance = Number.POSITIVE_INFINITY;

  TIMELINE_ZOOM_LEVELS.forEach((zoomLevel, index) => {
    const nextDistance = Math.abs(zoomLevel - numeric);
    if (nextDistance < bestDistance) {
      bestDistance = nextDistance;
      bestIndex = index;
    }
  });

  return bestIndex;
}

export function clampTimelineZoomLevel(value) {
  return TIMELINE_ZOOM_LEVELS[findClosestZoomIndex(value)];
}

export function getAdjacentTimelineZoomLevel(currentZoom, direction = 1) {
  const currentIndex = findClosestZoomIndex(currentZoom);
  const delta = direction >= 0 ? 1 : -1;
  const nextIndex = Math.max(
    0,
    Math.min(TIMELINE_ZOOM_LEVELS.length - 1, currentIndex + delta)
  );

  return TIMELINE_ZOOM_LEVELS[nextIndex];
}
